var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "left-image-wrapper" }, [
    _c("div", { class: ["image-wrapper", { "is-mobile": _vm.isMobile }] }, [
      _c("img", {
        attrs: { src: require(`@/assets/images/${_vm.dataSource.link}`) },
      }),
    ]),
    _c(
      "div",
      { staticClass: "content-wrapper" },
      [
        _c("div", { staticClass: "h2" }, [
          _vm._v(" " + _vm._s(_vm.dataSource.headerText) + " "),
        ]),
        _vm._l(_vm.dataSource.listArray, function (item, index) {
          return _c("div", {
            key: index,
            domProps: { innerHTML: _vm._s(item) },
          })
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }